import { render } from "./AdicionarGrupo.vue?vue&type=template&id=63650052&scoped=true"
import script from "./AdicionarGrupo.vue?vue&type=script&lang=js"
export * from "./AdicionarGrupo.vue?vue&type=script&lang=js"

import "./AdicionarGrupo.vue?vue&type=style&index=0&id=63650052&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63650052"]])

export default __exports__